import {
    useEffect,
    useEffectEvent,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useSubscriptions} from '../hooks/useSubscriptions';
import {Subscription} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";


export const SubscriptionsAutocomplete = ({
                                              field: {
                                                  name,
                                                  value: fieldValue,
                                              },
                                              form: {setFieldValue},
                                              ...rest
                                          }: FieldProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {items: records, fetchRecords} = useSubscriptions();

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const fetchOnMount = useEffectEvent(() => fetchRecords());

    useEffect(() => {
        fetchOnMount();
    }, []);

    const data = records.map((record: Subscription) => {
        return {
            ...record,
            label: record.id,
            value: record.id,
        };
    });

    const syncWithRecords = useEffectEvent(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: Subscription) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue((found as Subscription & { name: string }).name);
        }
    });

    useEffect(() => {
        syncWithRecords();
    }, [records.length]);

    const handleChange = (value: string) => {
        if (!Array.isArray(data)) {
            throw new Error('Data is expected to be an array');
        }
        const found = data.find((item) => item.label === value);

        if (found) {
            setFieldValue(name, found.id);
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Component'
            {...rest}
        />
    );
};
